import React, { useEffect } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { Add, Delete, Visibility } from '@material-ui/icons';
import { ConstantPermissions } from 'contexts/useConstant';
import ReactTable from 'components/ReactTable/ReactTable';
import { wsFindBy, wsRemove } from 'services/WService';
import Button from 'components/CustomButtons/Button';
import { useNavigate, Link } from 'react-router-dom';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Toasty, useToasty } from 'hooks/Toasty';
import { makeStyles } from '@material-ui/core';
import { WithApp } from 'contexts/appContext';
import Badge from 'components/Badge/Badge';
import { nDecimal } from 'hooks/Pipe';
import { useState } from 'react';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const useStyles = makeStyles(() => ({
  ...styles,
}));

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  { Header: 'Procesado', accessor: 'DeposId', width: 120, excelEnabled: false, align: 'center' },
  { Header: 'Tipo', accessor: 'DeposType', width: 80, align: 'center' },
  { Header: 'Fecha depósito', accessor: 'DeposDate', width: 150, align: 'center' },
  { Header: 'Banco', accessor: 'DpsBank', width: 150, align: 'center' },
  { Header: 'Cuenta deposito', accessor: 'BanckAcct', width: 150, align: 'center' },
  { Header: 'Moneda', accessor: 'DeposCurr', width: 90, align: 'center' },
  { Header: 'Monto', accessor: 'LocTotal', width: 150 },
  { Header: 'Descripición', accessor: 'Memo', width: 200 },
  { Header: 'Rerefencia', accessor: 'Ref2', width: 150, align: 'center' },
  { Header: 'Cuenta efectivo', accessor: 'AllocAcct', width: 150, align: 'center' },
  { Header: 'Método pago', accessor: 'U_SYP_MPPG', width: 150, align: 'center' },
  { Header: 'Usuario', accessor: 'oauth_user_id', width: 100, align: 'center' },
  { Header: 'Fecha creación', accessor: 'created_at', width: 150, align: 'center' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

function DepositList(props) {
  const classes = useStyles();
  const navigate = useNavigate();
  const [deposits, setDeposits] = useState([]);
  const [notify, showNotify] = useToasty();

  const [filter, setFilter] = useState({});
  const [alert, setAlert] = useState(null);
  const [dataLoading, setDataLoading] = useState(false);

  async function listDeposits() {
    setDataLoading(true);
    let res = await wsFindBy('pymt/deposit', filter);
    setDataLoading(false);
    if (res.success) {
      setDeposits(res.data);
    }
  }

  async function anulateDeposit(deposit) {
    setAlert(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title={`¿Está seguro de anular el depósito ${deposit.DpsBank} ${deposit.Memo}?`}
        onConfirm={async () => {
          setDataLoading(true);
          setAlert(null);
          let res = await wsRemove('pymt/deposit', deposit.id);
          setDataLoading(false);
          if (res.success) {
            showNotify(res.message);
            listDeposits();
          } else {
            showNotify(res.message, 'error');
          }
        }}
        onCancel={() => setAlert(null)}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      >
        Esta acción no se puede revertir
      </SweetAlert>,
    );
  }

  useEffect(() => {
    if (Object.keys(filter).length === 0) {
      return;
    }
    listDeposits();
  }, [filter]);

  return (
    <CardContainer
      // title="Listado de depositos"
      title={(<>Listado de depositos {dataLoading && <LoadingSpinner />}</>)}
      color="success"
      permission={ConstantPermissions.PYMT_DEPOSITS_STORE}
      icon={<Add />}
      onClick={() => navigate(`0`)}
    >
      <Toasty action={notify} />
      {alert}
      <FilterCustom dateRange diffRange={7} getFilter={setFilter} zone />
      <ReactTable
        defaultWidth={1900}
        columns={columns}
        formatDate="DD-MM-YYYY"
        data={deposits.map((item, i) => {
          return {
            ...item,
            num: (
              <div className="actions-right">
                {i + 1}
                <AllowedGuard permission={ConstantPermissions.PYMT_DEPOSITS_SHOW}>
                  <Link to={`${item.id}`}>
                    <Button justIcon round simple color="primary">
                      <Visibility />
                    </Button>
                  </Link>
                </AllowedGuard>
                <AllowedGuard permission={ConstantPermissions.PYMT_DEPOSITS_DESTROY}>
                  <Button
                    justIcon
                    round
                    simple
                    color="danger"
                    onClick={() => anulateDeposit(item)}
                    disabled={item.sapAnnuled !== null}
                  >
                    <Delete />
                  </Button>
                </AllowedGuard>
              </div>
            ),
            // Procesado
            DeposId:
              item.sapAnnuled !== null ? (
                <Badge color={item.sapAnnuled === 'P' ? 'warning' : 'danger'}>
                  {item.sapAnnuled === 'P' ? 'Procesando anulación' : 'Anulado'}
                </Badge>
              ) : (
                <Badge color={item.DeposId === null ? 'warning' : 'success'}>
                  {item.DeposId === null ? 'No' : 'Si'}
                </Badge>
              ),
            // DeposType
            DeposType: item.DeposType === 'C' ? 'Cash' : 'Cheque',
            LocTotal: nDecimal(item.LocTotal),
          };
        })}
      />
    </CardContainer>
  );
}

export default WithApp(DepositList);
